var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-300 3.2 17.9 19.5",
    preserveAspectRatio: "xMinYMin meet"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-282.1 21.3l-5.2-5.3c1.3-1.4 2-3.2 2-5.2 0-4.2-3.3-7.6-7.4-7.6s-7.3 3.4-7.3 7.6 3.3 7.6 7.4 7.6c1.7 0 3.3-.6 4.6-1.7l5.2 5.3.7-.7zM-299 10.8c0-3.6 2.9-6.6 6.4-6.6s6.4 3 6.4 6.6-2.9 6.6-6.4 6.6-6.4-3-6.4-6.6z"
  })));
}

export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' x='0' y='0' viewBox='-300 3.2 17.9 19.5' xml:space='preserve' preserveAspectRatio='xMinYMin meet'%3e%3cstyle type='text/css'%3e %3c/style%3e%3cpath d='M-282.1 21.3l-5.2-5.3c1.3-1.4 2-3.2 2-5.2 0-4.2-3.3-7.6-7.4-7.6s-7.3 3.4-7.3 7.6 3.3 7.6 7.4 7.6c1.7 0 3.3-0.6 4.6-1.7l5.2 5.3L-282.1 21.3zM-299 10.8c0-3.6 2.9-6.6 6.4-6.6s6.4 3 6.4 6.6 -2.9 6.6-6.4 6.6S-299 14.4-299 10.8z'/%3e%3c/svg%3e";
export { SvgSearch as ReactComponent };